import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import { galleryList } from "@/mocks/gallery";
import { specialList } from "@/mocks/special";

export default function HomeProfileSection() {
  const stats = [
    { label: "年表演经历", value: "27" },
    { label: "影视作品", value: String(worksList.length + 20) },
    { label: "归档资讯", value: String(newsList.length * 6) },
    { label: "写真图片", value: String(galleryList.length * 8) },
  ];

  return (
    <section className="w-full border-t border-background-200 bg-secondary-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16">
        <div>
          <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.28em] text-primary-700">
            <span className="h-[1px] w-6 bg-primary-500"></span>
            About This Site
          </div>
          <h2 className="mt-3 max-w-2xl font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[30px]">
            一个把张柏芝的每一次出现都认真归档的资讯站
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-700">
            我们从公开报道中整理新闻，按角色梳理影视作品的资料，把写真与活动现场的照片按时间和光分类。
            站点不做排名，也不追逐话题，只希望你在任何一个时间点打开，都能快速找到想看的那一页。
          </p>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
            本站为非官方粉丝整理的资讯站点，内容为示范性质，用于展示页面结构与交互效果。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-50 p-4">
                <p className="font-heading text-2xl font-semibold text-primary-600">{stat.value}</p>
                <p className="mt-1 text-[11px] text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-background-50 p-6">
          <h3 className="font-heading text-base font-semibold text-foreground-950">快速入口</h3>
          <ul className="mt-4 grid grid-cols-2 gap-3">
            {[
              { label: "新闻资讯", to: "/news", icon: "ri-newspaper-line", count: `${newsList.length} 篇` },
              { label: "影视作品", to: "/works", icon: "ri-film-line", count: `${worksList.length} 部` },
              { label: "写真图集", to: "/gallery", icon: "ri-image-line", count: `${galleryList.length} 组` },
              { label: "特别专题", to: "/special", icon: "ri-bookmark-line", count: `${specialList.length} 个` },
            ].map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="group flex h-full flex-col gap-2 rounded-md border border-background-200 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${link.icon} text-sm`} aria-hidden="true"></i>
                  </span>
                  <span className="mt-1 flex items-center justify-between text-sm text-foreground-900">
                    {link.label}
                    <i className="ri-arrow-right-up-line text-xs text-foreground-400 transition-colors group-hover:text-primary-600" aria-hidden="true"></i>
                  </span>
                  <span className="text-[11px] text-foreground-500">{link.count}</span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-center justify-between rounded-md bg-accent-100/70 px-4 py-3">
            <div>
              <p className="text-xs text-accent-900">有想补充的资料？</p>
              <p className="mt-0.5 text-[11px] text-accent-800">欢迎通过反馈表单联系我们</p>
            </div>
            <Link
              to="/about"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-accent-500 text-background-50 transition-colors hover:bg-accent-600"
              aria-label="前往反馈表单"
            >
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}